import { mock } from "../../conf/context";
import ajax from "../../lib/appfuse-react/core/ajax";
import downloader from "../../lib/appfuse-react/core/downloader";

const registrationService = {

    requestToken: async (email) => {
        const response = await ajax.get('registration/requestToken', {email});
        return response.ok;
    },
    verifyEmail: async (email, token) => {
        const response = await ajax.get('registration/verifyEmail', {email, token});
        return response.ok;
    },
    // 境內註冊資料檢核
    domesticValidate: async (data) => {
        const response = await ajax.post('registrations/domestic/validate', data);
        return response.data;
    },
    // 境內註冊資料送出
    domesticPost: async (data) => {
        await ajax.post('registrations/domestic', data);
    },

    // 境外註冊資料檢核
    overseasValidate: async (data) => {
        const response = await ajax.post('registrations/overseas/validate', data);
        return response.data;
    },
    // 境外註冊資料送出
    overseasPost: async (data) => {
        await ajax.post('registrations/overseas', data);
    },
    // 下載QF-P024
    downloadQFP024OrganicProductFile: async () => {
        await downloader.save('registrations/download/organicProductFileTemplate');
    }
}

export default registrationService;